import { Typography, TypographyProps } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

const PlanCardTitle: React.FC<TypographyProps> = ({
  children,
  className,
  ...props
}) => (
  <Typography
    data-testid={'PlanName'}
    fontWeight="bold"
    variant="body1"
    className={cn(
      'line-clamp-2 flex max-w-full min-w-0 flex-col overflow-hidden text-left wrap-break-word',
      className,
    )}
    {...props}
  >
    {children}
  </Typography>
);

export default PlanCardTitle;
